import React from "react";
import { DialogBody, DialogHeader } from "components/common/dialogs/GenericDialog";
import { useLocale } from "lib/hooks/useLocale";
import GenericButton from "components/common/buttons/GenericButton";

interface ExitPaymentProps {
  setIsOpen: (value: boolean) => void;
  handleExitPayment: () => void;
}

const ExitPayment: React.FC<ExitPaymentProps> = ({ setIsOpen, handleExitPayment }) => {
  const { t } = useLocale();

  return (
    <>
      <DialogHeader>
        <div className="flex flex-col space-y-4 py-4 text-base ">
          <h1 className="font-medium text-carbon-dark">{t("exit_checkout_header")}</h1>
          <h2 className="font-normal text-coal-dark">{t("exit_checkout_subheader")}</h2>
        </div>
      </DialogHeader>
      <DialogBody>
        <div className="relative flex w-full gap-4 px-6 pb-4 pt-14">
          <GenericButton
            buttonText={t("yes_exit")}
            height="h-14"
            customClass="bg-[#E06F39] rounded-2xl text-white"
            onClick={handleExitPayment}
          />

          <GenericButton
            buttonText={t("no")}
            height="h-14"
            customClass="border-2 rounded-2xl text-coal-dark"
            onClick={() => setIsOpen(false)}
          />
        </div>
      </DialogBody>
    </>
  );
};

export default ExitPayment;
